<div class="host-hostex-panel">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "word.date" | translate }}
      <!-- Date -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row justify-between">
          <host-range-picker
            class="flex-1 mr-5"
            [showFooter]="false"
            [size]="'large'"
            [disabledDate]="disabledDate"
            [(ngModel)]="dateRange"
            (ngModelChange)="onChangeDate($event)"></host-range-picker>
          <div class="extra">
            {{
              (nights > 1 ? "component.sidebar.plural.total_nights" : "component.sidebar.singular.total_nights")
                | translate
                  : {
                      nights: nights
                    }
            }}
            <!-- 共{{ nights }}晚 -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "component.sidebar.status_form_title_status" | translate }}
      <!-- 房态 -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-radio-group
            #radioBtnGroup
            [nzSize]="'large'"
            [ngModel]="available"
            (ngModelChange)="onAvailableChange($event)"
            [nzButtonStyle]="'solid'">
            <label nz-radio-button [nzValue]="1">{{ "component.sidebar.status_on" | translate }}</label>
            <label nz-radio-button [nzValue]="0">{{ "component.sidebar.status_off" | translate }}</label>
          </nz-radio-group>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "word.house" | translate }}</div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-option-list">
          @for (house of selectedHouses(); track house.value) {
            <div class="v4-option-item">
              <div class="v4-option">
                {{ house.label }}
                <span (click)="onRemoveHouse(house.value)" class="remove-icon">
                  <i nz-icon nzType="close" nzTheme="outline"></i>
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="relative">
          <span class="cursor-pointer leading-[32px] relative text-primary"
            >+{{ "component.sidebar.btn.add_house" | translate }}</span
          >
          <div class="absolute top-0 z-10 v4-house-select-hide-trigger">
            <v4-house-select
              [ngModel]="selectedHouseIds()"
              [showDeleted]="false"
              (onSelectValues)="onSelectHouses($event)"></v4-house-select>
          </div>
        </div>

        <!-- <a
          nz-button
          nzType="link"
          nzSize="small"
          nz-dropdown
          nzTrigger="click"
          [(nzVisible)]="housePickerVisible"
          [nzBackdrop]="false"
          [nzDropdownMenu]="dropdown"
          [nzPlacement]="'bottomCenter'"
          >+{{ "component.sidebar.btn.add_house" | translate }}</a
        >
        <nz-dropdown-menu #dropdown="nzDropdownMenu">
          <host-houses-picker
            [selectedHouses]="houses"
            (cancel)="housePickerVisible = false"
            (select)="onHousePickerSelected($event)"
          ></host-houses-picker>
        </nz-dropdown-menu> -->
      </div>
    </div>
  </div>

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzType="primary" nzSize="large" hostThrottleClick (click)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>
